export enum SessionStorageKeys {
  HAS_CLOSED_SIGNUP_POPUP = 'has-closed-signup-popup',
  LANDING_PAGE_EMAIL = 'landing-page-email',
}
